import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import IndustriesPage from "./pages/IndustriesPage";
import HowWeWorkPage from "./pages/HowWeWorkPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import LandscapeMaintenancePage from "./pages/LandscapeMaintenancePage";
import IrrigationManagementPage from "./pages/IrrigationManagementPage";
import PressureWashingPage from "./pages/PressureWashingPage";
import ExteriorAssetCarePage from "./pages/ExteriorAssetCarePage";
import PasadenaLandingPage from "./pages/PasadenaLandingPage";
import LaCanadaLandingPage from "./pages/LaCanadaLandingPage";
import SanMarinoLandingPage from "./pages/SanMarinoLandingPage";
import ArcadiaLandingPage from "./pages/ArcadiaLandingPage";
import MobileLandingPage from "./pages/MobileLandingPage";
import LawnSignLandingPage from "./pages/LawnSignLandingPage";
import FlyerLandingPage from "./pages/FlyerLandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin routes without Layout */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          
          {/* QR Code Landing Pages (no Layout) */}
          <Route path="/pasadena" element={<PasadenaLandingPage />} />
          <Route path="/la-canada-flintridge" element={<LaCanadaLandingPage />} />
          <Route path="/san-marino" element={<SanMarinoLandingPage />} />
          <Route path="/arcadia" element={<ArcadiaLandingPage />} />
          <Route path="/mobile" element={<MobileLandingPage />} />
          <Route path="/lawn-sign" element={<LawnSignLandingPage />} />
          <Route path="/neighbor" element={<FlyerLandingPage />} />
          
          {/* Public routes with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/industries" element={<Layout><IndustriesPage /></Layout>} />
          <Route path="/how-we-work" element={<Layout><HowWeWorkPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          
          {/* Legal / Compliance Pages */}
          <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          
          {/* Individual Service Pages */}
          <Route path="/landscape-maintenance" element={<Layout><LandscapeMaintenancePage /></Layout>} />
          <Route path="/irrigation-management" element={<Layout><IrrigationManagementPage /></Layout>} />
          <Route path="/pressure-washing" element={<Layout><PressureWashingPage /></Layout>} />
          <Route path="/exterior-asset-care" element={<Layout><ExteriorAssetCarePage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
